import { gql, makeVar } from '@apollo/client'
import { IHub } from '@core/auth/hooks/use-get-hubs-list/use-get-hubs-list.hook.types'

export const hubSelected = makeVar<IHub | null>(null)

export const setHubSelectedApollo = (_hubSelected: IHub | null) =>
  hubSelected(_hubSelected)

export const GET_HUBS_SELECTED = gql`
  query hubSelected {
    hubSelected @client
  }
`
